import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchObjects } from '../redux/migrationThunks';

function useFetchObjects(sourceId, selectedObjectType, sourceType) {
  const dispatch = useDispatch();
  const [objects, setObjects] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadObjects = async () => {
      if (!sourceId || !selectedObjectType) return;
      
      setLoading(true);

      try {
        const result = await dispatch(fetchObjects({ 
          sourceId, 
          objectType: selectedObjectType 
        })).unwrap();
        
        setObjects(Array.isArray(result?.data) ? result.data : []);
      } catch (error) {
        setObjects([]);
      } finally {
        setLoading(false);
      }
    };
    
    loadObjects();
  }, [sourceId, selectedObjectType, sourceType, dispatch]);

  return { objects, setObjects, loading };
}

export default useFetchObjects;
